const IS_LOADING = "lists/advertiser_types/IS_LOADING";
const IS_ERROR = "lists/advertiser_types/IS_ERROR";
const ADVERTISERLIST = "lists/advertiser_types/ADVERTISERLIST";
const EDIT = "lists/advertiser_types/EDIT";

export { IS_LOADING, IS_ERROR, ADVERTISERLIST, EDIT };
